import { render, staticRenderFns } from "./ProductPrompt.vue?vue&type=template&id=7a84aa0a&"
import script from "./ProductPrompt.vue?vue&type=script&lang=js&"
export * from "./ProductPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports